var _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _clipPath6, _clipPath7, _clipPath8, _clipPath9, _clipPath0, _clipPath1, _clipPath10, _filter, _filter2, _filter3, _filter4, _filter5, _filter6, _filter7, _mask, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 430,
    height: 430,
    style: {
      width: "100%",
      height: "100%",
      transform: "translate3d(0,0,0)",
      contentVisibility: "visible"
    },
    viewBox: "0 0 430 430",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "sxm65o35"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h430v430H0z"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "6d7knrg3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h430v430H0z"
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "z8jpaieg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h430v430H0z"
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "7c164dyt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h430v430H0z"
  }))), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "so4jaihf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h430v430H0z"
  }))), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "26jst172"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h430v430H0z"
  }))), _clipPath7 || (_clipPath7 = /*#__PURE__*/React.createElement("clipPath", {
    id: "a2mcr85g"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h430v430H0z"
  }))), _clipPath8 || (_clipPath8 = /*#__PURE__*/React.createElement("clipPath", {
    id: "jiudiolw"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h430v430H0z"
  }))), _clipPath9 || (_clipPath9 = /*#__PURE__*/React.createElement("clipPath", {
    id: "09buzw57"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h430v430H0z"
  }))), _clipPath0 || (_clipPath0 = /*#__PURE__*/React.createElement("clipPath", {
    id: "up0kp2xp"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h430v430H0z"
  }))), _clipPath1 || (_clipPath1 = /*#__PURE__*/React.createElement("clipPath", {
    id: "81k8frul"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h430v430H0z"
  }))), _clipPath10 || (_clipPath10 = /*#__PURE__*/React.createElement("clipPath", {
    id: "bqt96bem"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h430v430H0z"
  }))), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "cg21kr6x",
    width: "100%",
    height: "100%",
    x: "0%",
    y: "0%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "SourceGraphic"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    tableValues: "1.0 0.0",
    type: "table"
  })))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "thlyr8in",
    width: "100%",
    height: "100%",
    x: "0%",
    y: "0%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "SourceGraphic"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    tableValues: "1.0 0.0",
    type: "table"
  })))), _filter3 || (_filter3 = /*#__PURE__*/React.createElement("filter", {
    id: "p477xx6a",
    width: "100%",
    height: "100%",
    x: "0%",
    y: "0%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "SourceGraphic"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    tableValues: "1.0 0.0",
    type: "table"
  })))), _filter4 || (_filter4 = /*#__PURE__*/React.createElement("filter", {
    id: "fu1agb1g",
    width: "100%",
    height: "100%",
    x: "0%",
    y: "0%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "SourceGraphic"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    tableValues: "1.0 0.0",
    type: "table"
  })))), _filter5 || (_filter5 = /*#__PURE__*/React.createElement("filter", {
    id: "5u0vdrib",
    width: "100%",
    height: "100%",
    x: "0%",
    y: "0%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "SourceGraphic"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    tableValues: "1.0 0.0",
    type: "table"
  })))), _filter6 || (_filter6 = /*#__PURE__*/React.createElement("filter", {
    id: "5dj0l2y6",
    width: "100%",
    height: "100%",
    x: "0%",
    y: "0%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "SourceGraphic"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    tableValues: "1.0 0.0",
    type: "table"
  })))), _filter7 || (_filter7 = /*#__PURE__*/React.createElement("filter", {
    id: "jrhoicng",
    width: "100%",
    height: "100%",
    x: "0%",
    y: "0%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "SourceGraphic"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    tableValues: "1.0 0.0",
    type: "table"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "f25q8nxw",
    "mask-type": "alpha"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#cg21kr6x)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h430v430H0z",
    opacity: 0
  })))), /*#__PURE__*/React.createElement("g", {
    id: "ip60v5my",
    style: {
      display: "none"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", null)), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", null)), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", null)), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", null)), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", null)), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", null))), /*#__PURE__*/React.createElement("g", {
    id: "0v4uhqyx",
    style: {
      display: "none"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", null)), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", null))), /*#__PURE__*/React.createElement("g", {
    id: "8cbxqxnb",
    style: {
      display: "none"
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", null)), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", null))), /*#__PURE__*/React.createElement("g", {
    id: "q9ijsj4e",
    style: {
      display: "none"
    }
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", null)), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", null))), /*#__PURE__*/React.createElement("path", {
    id: "fvi2dac3",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "2x5por4q",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "qzqbwdeb",
    style: {
      display: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#sxm65o35)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#81k8frul)",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    className: "secondary",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bqt96bem)",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    className: "primary",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    className: "primary",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    className: "secondary",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    className: "secondary",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#r)",
    style: {
      display: "none"
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    className: "primary"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    className: "primary",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    className: "primary",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    className: "primary",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    className: "primary",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#s)",
    style: {
      display: "none"
    }
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    className: "primary"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    style: {
      display: "none"
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "primary"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "primary"
  }))))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    clipPath: "url(#up0kp2xp)",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "none"
    }
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "primary"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "primary"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "secondary"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "secondary"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "primary"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "primary"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "secondary"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "secondary",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "secondary",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "secondary",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "secondary",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "secondary",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "secondary",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "secondary",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "secondary",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "secondary",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "secondary",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "secondary",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "secondary",
    style: {
      display: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a2mcr85g)",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#09buzw57)",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    className: "primary",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    className: "primary",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    className: "secondary",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    className: "secondary",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#w)",
    style: {
      display: "none"
    }
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    className: "primary"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    className: "primary",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    className: "primary",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    className: "primary",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    className: "primary",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#x)",
    style: {
      display: "none"
    }
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    className: "primary"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    style: {
      display: "none"
    }
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "primary"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "primary"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#jiudiolw)",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    className: "primary",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    className: "primary",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    className: "secondary",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    className: "secondary",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#z)",
    style: {
      display: "none"
    }
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    className: "primary"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    className: "primary",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    className: "primary",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    className: "primary",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    className: "primary",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#A)",
    style: {
      display: "none"
    }
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    className: "primary"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    style: {
      display: "none"
    }
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "primary"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "primary"
  })))), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    className: "secondary",
    style: {
      display: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    clipPath: "url(#26jst172)",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "none"
    }
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "primary"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "primary"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "secondary"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "secondary"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "primary"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "primary"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "secondary"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "secondary",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "secondary",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "secondary",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "secondary",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "secondary",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "secondary",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "secondary",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "secondary",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "secondary",
    style: {
      display: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    clipPath: "url(#7c164dyt)",
    style: {
      display: "block"
    }
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#so4jaihf)",
    mask: "url(#f25q8nxw)",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "secondary",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "secondary",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "primary",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "primary",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "primary",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "secondary",
    style: {
      display: "none"
    }
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#0260FE",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 13.3,
    d: "M-29.756 30.067c12.93 12.93 33.888 12.93 46.818 0s12.925-33.882 0-46.807c-12.93-12.93-33.888-12.919-46.818 0s-12.93 33.877 0 46.807z",
    className: "secondary",
    style: {
      display: "block"
    },
    transform: "matrix(.9 0 0 .9 250.614 165.97)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0260FE",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 13.3,
    d: "m-32.955-34.543-2.637 3.788c-8.874 21.667-5.792 43.894 8.008 57.694 13.8 13.8 36.027 16.882 57.694 8.008l4.098-1.728",
    className: "secondary",
    style: {
      display: "block"
    },
    transform: "matrix(.9 0 0 .9 164.353 253.646)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#171663",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 13.3,
    d: "M53.821-55.51S37.948-41.87.794-41.87s-53.975-14.162-53.975-14.162M68.524 135.587c-1.804 9.652-10.273 15.836-20.095 15.836h-96.858c-9.822 0-18.281-6.176-20.094-15.836-4.281-22.853-7.385-52.121-5.794-95.005 1.583-42.665 8.261-66.022 20.596-96.291 12.266-30.102 30.38-55.481 53.841-73.71 23.525 18.28 42.064 43.348 54.331 73.55 12.272 30.216 19.343 61.251 20.652 94.88 1.669 42.898-2.298 73.723-6.579 96.576z",
    className: "primary",
    style: {
      display: "block"
    },
    transform: "rotate(45 -54.8 393.876) scale(.9)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#171663",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 13.3,
    d: "M-37.535-8.496s22.479 25.64 21.701 73.951C35.5 11.589 26.043-58.789 26.043-58.789",
    className: "primary",
    style: {
      display: "block"
    },
    transform: "matrix(.9 0 0 .9 247.05 296.07)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#171663",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 13.3,
    d: "M10.195 39.234s-24.638-19.255-72.648-20.398C-9.443-29.465 59.402-22.096 59.402-22.096",
    className: "primary",
    style: {
      display: "block"
    },
    transform: "matrix(.9 0 0 .9 118.498 167.518)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0260FE",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 12,
    d: "M-90.79 119.409c-11.262 11.262-40.165 19.774-62.811 22.028 3.264-23.656 10.765-51.55 22.027-62.812s29.522-11.262 40.784 0 11.262 29.522 0 40.784z",
    className: "secondary",
    style: {
      display: "block"
    },
    transform: "translate(215.113 214.904)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "secondary",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "secondary",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "secondary",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "secondary",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "secondary",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "secondary",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "secondary",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "secondary",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "secondary",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "secondary",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "secondary",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "secondary",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "secondary",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "secondary",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "secondary",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "none"
    }
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "secondary"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "secondary"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "secondary"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "secondary"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "secondary"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "secondary"
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    clipPath: "url(#z8jpaieg)",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "secondary",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "secondary",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "primary",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "primary",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "primary",
    style: {
      display: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    clipPath: "url(#6d7knrg3)",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "secondary",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "none"
    }
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "primary"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "primary"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "secondary"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "primary"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "primary"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "secondary",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "secondary",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "secondary",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "secondary",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "secondary",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "secondary",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "secondary",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "secondary",
    style: {
      display: "none"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.b86e88022ad100ccb0b56afe14ce5d84.svg";
export { ForwardRef as ReactComponent };